"use client"

import { useState } from "react"
import { motion } from "framer-motion"
import { Search } from "lucide-react"

const LyricsForm = ({ onSubmit, isLoading }) => {
  const [singer, setSinger] = useState("")
  const [songTitle, setSongTitle] = useState("")

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(singer, songTitle)
  }

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <div className="mb-4">
        <label htmlFor="singer" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Artist Name
        </label>
        <input
          id="singer"
          type="text"
          placeholder="Enter artist name"
          value={singer}
          onChange={(e) => setSinger(e.target.value)}
          required
          className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500"
        />
      </div>
      <div className="mb-6">
        <label htmlFor="songTitle" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Song Title
        </label>
        <input
          id="songTitle"
          type="text"
          placeholder="Enter song title"
          value={songTitle}
          onChange={(e) => setSongTitle(e.target.value)}
          required
          className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500"
        />
      </div>
      <button
        type="submit"
        disabled={isLoading}
        className="w-full bg-indigo-600 text-white p-3 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50 transition-colors duration-300 flex items-center justify-center"
      >
        {isLoading ? (
          <span className="animate-pulse">Searching...</span>
        ) : (
          <>
            <Search className="mr-2" size={18} />
            Find Lyrics
          </>
        )}
      </button>
    </motion.form>
  )
}

export default LyricsForm

